var _circle, _path, _circle2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResolvedRepaired(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Resolved Repaired") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    fill: "#000000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6279 26.0579C41.2423 26.4514 41.0263 26.9803 41.0263 27.5312C41.0263 28.0821 41.2423 28.6111 41.6279 29.0045L44.9955 32.3721C45.3889 32.7577 45.9179 32.9737 46.4688 32.9737C47.0197 32.9737 47.5486 32.7577 47.9421 32.3721L55.8768 24.4373C56.9352 26.776 57.2556 29.3818 56.7955 31.9072C56.3353 34.4327 55.1164 36.758 53.3013 38.5731C51.4861 40.3883 49.1608 41.6072 46.6353 42.0674C44.1099 42.5275 41.5041 42.2071 39.1654 41.1487L24.6218 55.6923C23.7845 56.5296 22.6489 57 21.4648 57C20.2806 57 19.145 56.5296 18.3077 55.6923C17.4704 54.855 17 53.7194 17 52.5352C17 51.3511 17.4704 50.2155 18.3077 49.3782L32.8513 34.8346C31.7929 32.4959 31.4725 29.8901 31.9327 27.3647C32.3928 24.8392 33.6117 22.5139 35.4269 20.6987C37.242 18.8836 39.5673 17.6647 42.0928 17.2045C44.6182 16.7444 47.224 17.0648 49.5627 18.1232L41.649 26.0369L41.6279 26.0579Z",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 63.5,
    r: 11.5,
    fill: "#05C379"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3904 59.8536L61.2913 67.7073L57.6099 64.1375",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResolvedRepaired);
export default __webpack_public_path__ + "static/media/resolved-repaired.959d55aeccdc0c2a9ca3e5d5af9eb257.svg";
export { ForwardRef as ReactComponent };